<template>
	<div>
			<ProgressSpinner :style="`${width1} ${height1}`" :strokeWidth="stroke1" fill="var(--red-600)"	animationDuration="1s" />
	</div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "loaderRing",
  setup() {},
  props: {
    diameter: {
      type: Number,
      required: false
    },
    stroke: {
      type: Number,
      required: false
    },
  },
  watch: {
  },
  computed: {
    width1: function () {
      if (this.diameter > 0) return `width: ${this.diameter}px;`;
      else return 'width: 50px;';
    },
    height1: function () {
      if (this.diameter > 0) return `height: ${this.diameter}px`;
      else return 'height: 50px;';
    },
    stroke1: function () {
      if (this.stroke > 0) return `${this.stroke}`;
      else return 4;
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
  },
  methods: {
  },
});
</script>

<style lang="scss" scoped>
</style>